import { generateTestId } from "@client-shared";

export const setSsSkuSelectionModalTestId = (identifier: string): string => generateTestId("SsSkuSelectionModal", identifier);
